import React from 'react';
import { Heart, Github, Twitter, Mail, MessageSquare } from 'lucide-react';

interface FooterProps {
  onNavigate?: (page: 'privacy' | 'terms' | 'contact') => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-slate-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left Section - Brand */}
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600 dark:text-gray-400">
              © {currentYear} <span className="font-semibold text-cyan-600 dark:text-cyan-400">FXPrompt</span>
            </span>
            <span className="text-gray-400 dark:text-gray-600">•</span>
            <span className="text-sm text-gray-600 dark:text-gray-400">
              Made with <Heart className="w-3 h-3 inline text-red-500 fill-red-500" /> by <a href="https://flickmax.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors">Flickmax.com</a>
            </span>
          </div>

          {/* Center Section - Links */}
          <div className="flex items-center gap-6">
            <button 
              onClick={() => onNavigate?.('privacy')}
              className="text-sm text-gray-600 dark:text-gray-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors"
            >
              Privacy
            </button>
            <button 
              onClick={() => onNavigate?.('terms')}
              className="text-sm text-gray-600 dark:text-gray-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors"
            >
              Terms
            </button>
            <button 
              onClick={() => onNavigate?.('contact')}
              className="text-sm text-gray-600 dark:text-gray-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors flex items-center gap-1"
            >
              <MessageSquare className="w-3 h-3" />
              Contact
            </button>
          </div>

          {/* Right Section - Social */}
          <div className="flex items-center gap-3">
            <a 
              href="https://github.com/yourusername" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 dark:text-gray-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors"
              aria-label="GitHub"
            >
              <Github className="w-4 h-4" />
            </a>
            <a 
              href="https://twitter.com/yourusername" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 dark:text-gray-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors"
              aria-label="Twitter"
            >
              <Twitter className="w-4 h-4" />
            </a>
            <a 
              href="mailto:support@fxprompt.app" 
              className="text-gray-600 dark:text-gray-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors"
              aria-label="Email"
            >
              <Mail className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Bottom Section - Additional Info (Mobile) */}
        <div className="mt-6 pt-6 border-t border-gray-200 dark:border-slate-800 text-center md:hidden">
          <p className="text-xs text-gray-500 dark:text-gray-500">
            Professional AI Prompt Generator for Creators
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;